<script setup lang="ts">
    import { computed, toRef } from 'vue'

    const props = defineProps<{
        context?: string
        errors?: { Context: string; Error: string }[]
    }>()

    const context = toRef(props, 'context')
    const errors = toRef(props, 'errors')

    const error = computed(() =>
        errors.value?.find(e => e.Context === context.value) ?? null
    )
</script>


<template>
    <div class="error">{{error ? error.Error : ''}}</div>
</template>
